export default "__VITE_ASSET__CT465qM___"